export default "__VITE_ASSET__BNENXhVR__"